import React, { useLayoutEffect, useState } from 'react';

const PortLinkOverlay = ({ containerRef, activeLink, portAnchors, anchorVersion }) => {
  const [path, setPath] = useState(null);

  useLayoutEffect(() => {
    if (!activeLink || !containerRef?.current) {
      setPath(null);
      return;
    }

    const container = containerRef.current;
    const rect = container.getBoundingClientRect();
    const fromEl = portAnchors.current[activeLink.from_port_id];
    const toEl = portAnchors.current[activeLink.to_port_id];

    if (!fromEl || !toEl) {
      setPath(null);
      return;
    }

    const fromRect = fromEl.getBoundingClientRect();
    const toRect = toEl.getBoundingClientRect();

    const x1 = fromRect.left + fromRect.width / 2 - rect.left;
    const y1 = fromRect.top + fromRect.height / 2 - rect.top;
    const x2 = toRect.left + toRect.width / 2 - rect.left;
    const y2 = toRect.top + toRect.height / 2 - rect.top;

    setPath({
      x1,
      y1,
      x2,
      y2,
      cx: (x1 + x2) / 2,
      cy: Math.min(y1, y2) - 30,
    });
  }, [activeLink, anchorVersion, containerRef, portAnchors]);

  if (!path) return null;

  return (
    <svg
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 5,
      }}
    >
      <path
        d={`M ${path.x1} ${path.y1} Q ${path.cx} ${path.cy} ${path.x2} ${path.y2}`}
        fill="none"
        stroke="#1890ff"
        strokeWidth="2"
      />
    </svg>
  );
};

export default PortLinkOverlay;
